// API URLs
export const ZENO_API_URL =
  import.meta.env.VITE_ZENO_HTTP_URL || "https://zeno.devnet.mash.trade";

// Helper function to construct API URLs
export const getZenoApiUrl = (path: string) => {
  // In development, use the proxy
  if (import.meta.env.DEV) {
    return `/zeno${path}`;
  }
  // In production, use the full URL
  return `${ZENO_API_URL}${path}`;
};
